import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('authToken') || null,
  role: localStorage.getItem('authRole') || null,
};
initialState.isAuthenticated = Boolean(initialState.token);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.role = action.payload.role || null;
      localStorage.setItem('authToken', action.payload.token);
      if (action.payload.role) {
        localStorage.setItem('authRole', action.payload.role);
      } else {
        localStorage.removeItem('authRole');
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.role = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('authRole');
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
